import { FC } from "react";
import { TeamLogo } from "../../../../Components/TeamLogo";
import { TeamName } from "../../../../Components/TeamName";
import { ResolvedTeamReference } from "../../../../Components/ResolvedTeamReference";
import { useCompetition } from "../../../../hooks/useCompetition";
import { useLeaderboard } from "../../../../hooks/useLeaderboard";
import { getPresentationParamsForOrigin } from "../../../../getPresentationParamsForOrigin";

interface GroupStandingsCardProps {
  competitionId: string;
  groupId: string;
}

export const GroupStandingsCard: FC<GroupStandingsCardProps> = ({
  competitionId,
  groupId,
}) => {
  const competition = useCompetition(competitionId);
  const group = competition.data?.groups.find((g) => g.id === groupId);
  const leaderboard = useLeaderboard(competitionId, groupId);

  if (!group) {
    return null;
  }

  const hasSlots = group.slots && group.slots.length > 0;
  const isUnresolved = hasSlots && group.teamIds.length === 0;
  const brandColor = getPresentationParamsForOrigin().colors.brand[7];

  return (
    <div
      style={{
        backgroundColor: "rgb(30,30,30)",
        color: "white",
        padding: "30px",
      }}
    >
      <div
        style={{
          fontSize: "32px",
          fontWeight: 900,
          color: brandColor,
          textTransform: "uppercase",
          paddingBottom: "25px",
          borderBottom: "2px solid rgb(50,50,50)",
        }}
      >
        {group.name}
      </div>
      <div style={{ fontSize: "24px" }}>
        <table style={{ borderSpacing: "10px 15px" }}>
          <thead>
            <tr>
              <th colSpan={3}></th>
              <th style={{ textAlign: "center", width: "1%" }}>P</th>
            </tr>
          </thead>
          <tbody>
            {isUnresolved
              ? group.slots.slice(0, 4).map((slot, index) => (
                  <tr key={index}>
                    <td style={{ width: "1%", verticalAlign: "middle" }}>
                      {index + 1}.
                    </td>
                    <td style={{ width: "1%" }}>
                      <div
                        style={{
                          width: 30,
                          height: 30,
                          backgroundColor: "rgb(50,50,50)",
                          borderRadius: "4px",
                        }}
                      />
                    </td>
                    <td style={{ minWidth: 0, verticalAlign: "middle" }}>
                      <div
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: "vertical",
                          wordBreak: "break-all",
                          color: "rgb(150,150,150)",
                        }}
                      >
                        <ResolvedTeamReference
                          teamReference={slot}
                          competitionId={competitionId}
                        />
                      </div>
                    </td>
                    <td
                      style={{ textAlign: "center", verticalAlign: "middle" }}
                    >
                      –
                    </td>
                  </tr>
                ))
              : leaderboard.data?.leaderboard.slice(0, 4).map((l) => (
                  <tr key={l.teamId}>
                    <td style={{ width: "1%", verticalAlign: "middle" }}>
                      {l.position}.
                    </td>
                    <td style={{ width: "1%" }}>
                      <div style={{ width: 30 }}>
                        <TeamLogo height={30} teamId={l.teamId} />
                      </div>
                    </td>
                    <td style={{ minWidth: 0, verticalAlign: "middle" }}>
                      <div
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: "vertical",
                          wordBreak: "break-all",
                        }}
                      >
                        <TeamName variant="medium" teamId={l.teamId} />
                      </div>
                    </td>
                    <td
                      style={{ textAlign: "center", verticalAlign: "middle" }}
                    >
                      {l.points}
                    </td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
